function Team() {
  return (
    <div className="mt-4 About">
      <section class="text-black body-font">
        <div class="container mx-auto flex px-5 sm:py-8 py-2 items-center justify-center flex-col">
          <div class="text-center lg:w-2/3 w-full">
            <h1
              class="title-font sm:text-7xl text-4xl mb-4 font-medium  orange-text "
              style={{ fontFamily: "font1" }}
            >
              Team
            </h1>
            <section class="text-gray-600 body-font sm:text-lg text-xs">
              <div class="container px-5 sm:py-8 py-2 mx-auto">
                <div class="flex flex-wrap -m-4">
                  <div class="p-4 w-full sm:w-1/3">
                    <div class="h-full flex flex-col items-center text-left">
                      <div class="w-full">
                        <h2 class="title-font font-medium text-lg text-gray-900">
                          Jimbo
                        </h2>
                        <h3 class="text-gray-500 mb-3">Co-Founder</h3>
                        <ul
                          class="sm:mb-4 mb-1 "
                          style={{ listStyleType: "circle" }}
                        >
                          <li> Kansas City native, Go chiefs!</li>
                          <li>
                            {" "}
                            Moved down to Houston in June 2021 9-5: contractor
                            at NASA working on the ISS program.
                          </li>
                          <li>
                            {" "}
                            Bachelors: Aerospace Engineering Started investing
                            in NFTs in June of 2021.
                          </li>
                          <li>
                            {" "}
                            10+ years coding experience in everything from Basic
                            to C to JS and now Solidity 👀
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="p-4 w-full sm:w-1/3">
                    <div class="h-full flex flex-col items-center text-left">
                      <div class="w-full">
                        <h2 class="title-font font-medium text-lg text-gray-900">
                          Corbo
                        </h2>
                        <h3 class="text-gray-500 mb-3">Co-Founder</h3>
                        <ul
                          class="sm:mb-4 mb-1"
                          style={{ listStyleType: "circle" }}
                        >
                          <li>
                            {" "}
                            Kansas City born and raised Started trading NFTs
                            January of 2021
                          </li>{" "}
                          <li>
                            Junior year Computer Science student at Kansas State
                            University
                          </li>{" "}
                          <li>
                            {" "}
                            Taught myself solidity and started developing smart
                            contracts six months ago
                          </li>{" "}
                          <li>
                            {" "}
                            Coding experience going back to when I was 12 making
                            Minecraft mods
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="p-4 w-full sm:w-1/3">
                    <div class="h-full flex flex-col items-center text-left">
                      <div class="w-full">
                        <h2 class="title-font font-medium text-lg text-gray-900">
                          Arock
                        </h2>
                        <h3 class="text-gray-500 mb-3">Co-Founder</h3>
                        <ul
                          class="sm:mb-4 mb-1"
                          style={{ listStyleType: "circle" }}
                        >
                          <li>
                            {" "}
                            Born and raised KC native Junior at Kansas State
                            University Discord Wizard
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Team;
